import React from "react";
import Chart from "react-apexcharts";
import style from "./Radial.module.css";
import { Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";

const defaultGraphData = {
  all: 0,
  motor: 0,
  "a&h": 0,
};

const defaultCaseData = {
  all_totalCases: 0,
  motor_totalCases: 0,
  "a&h_totalCases": 0,
};

export default function Ageing({ radialDataState }) {
  const activeTab = useSelector((state) => state.AgeingTabSlice.activeTab);
  const [graphData, setGraphData] = useState({});
  const [showTotalCases, setShowTotalCases] = useState({});
  const options = {
    colors: ["#59CE8F", "#FFC700", "#E42125"],
    labels: ["Health", "Motor", "All Products"],
    legend: {
      show: false,
      floating: true,
      showForSingleSeries: false,
      showForNullSeries: true,
      showForZeroSeries: true,
      floating: false,
      fontSize: "1.2rem",
      fontFamily: "Inter",
      height: undefined,
      formatter: undefined,
      position: "center",
      offsetX: 0,
      offsetY: 10,
      labels: {
        useSeriesColors: true,
      },
      markers: {
        width: 27,
        height: 13,
        margin: 5,
        strokeWidth: 0,
        strokeColor: "#fff",
        radius: 6,
        customHTML: undefined,
        onClick: undefined,
        offsetX: 0,
        offsetY: 0,
      },
      onItemClick: {
        toggleDataSeries: true,
      },
      onItemHover: {
        highlightDataSeries: true,
      },
    },
    plotOptions: {
      radialBar: {
        size: undefined,
        inverseOrder: false,
        startAngle: 0,
        endAngle: 360,
        offsetX: 0,
        offsetY: 0,
        hollow: {
          margin: 5,
          size: "16%",
          background: "transparent",
          image: undefined,
          imageWidth: 150,
          imageHeight: 150,
          imageOffsetX: 0,
          imageOffsetY: 0,

          imageClipped: true,
          position: "front", // this is for percentage
          dropShadow: {
            enabled: true,
            top: 0,
            left: 0,
            blur: 5,
            opacity: 0.5,
          },
        },
        track: {
          show: true,
          startAngle: undefined,
          endAngle: undefined,
          background: "#f2f2f2",
          strokeWidth: "97%",
          opacity: 0,
          margin: 5,
          dropShadow: {
            enabled: true,
            top: 0,
            left: 0,
            blur: 3,
            opacity: 0.5,
          },
        },
        dataLabels: {
          show: false,
          name: {
            show: false,
            fontSize: "2.2rem",
            fontFamily: undefined,
            color: undefined,
            offsetY: -10,
          },
          value: {
            show: false,
            fontSize: "1.6rem",
            fontFamily: undefined,
            color: undefined,
            offsetY: 16,
            offsetX: 80,
            marginLeft: "2rem",
            formatter: function (val) {
              return val + "%";
            },
          },
          total: {
            show: false,
            label: "Total",
            color: "#373d3f",
            formatter: function (w) {
              return (
                w.globals.seriesTotals.reduce((a, b) => {
                  return a + b;
                }, 0) /
                  w.globals.series.length +
                "%"
              );
            },
          },
        },
      },
    },
  };

  useEffect(() => {
    let isTabValue = false;
    for (let key in radialDataState) {
      let tab = activeTab.replace(/ +/g, "");
      if (key.toLowerCase() === tab.toLowerCase()) {
        isTabValue = true;
        let newGraphData = { ...defaultGraphData };
        radialDataState?.[key]?.forEach((item) => {
          newGraphData[Object?.keys(item)?.[0]] = Object?.values(item)?.[0];
        });
        setGraphData(newGraphData);
        const totalcasesCount = { ...defaultCaseData };
        radialDataState?.[key]?.map((item) => {
          totalcasesCount[Object?.keys(item)?.[1]] = Object?.values(item)?.[1];
        });
        setShowTotalCases(totalcasesCount);
      }
    }
    if (!isTabValue) setGraphData({ ...defaultGraphData });
  }, [activeTab, radialDataState]);

  return (
    <Grid className={style.donut} container rowSpacing={1}>
      <Grid
        item
        sx={{ width: "100%", marginTop: "10px", paddingTop: 0 }}
        xs={6}
        sm={6}
        md={3}
        lg={3.5}
      >
        <div className={style.container1}>
          <div className={style.boxes}>
            <div className={style.box2}></div>
            <div className={style.box1}></div>
            <div className={style.box}></div>
          </div>
          <div className={style.labels}>
            <div>All Products</div>
            <div className={style.motor}>Motor</div>
            <span>Health</span>
          </div>
        </div>
      </Grid>
      <Grid
        item
        sx={{ width: "100%", marginTop: "20px" }}
        xs={6}
        sm={6}
        md={3}
        lg={3.5}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
            height: "100%",
            marginTop: "-3px",
            marginLeft: "7px",
          }}
        >
          {Object?.keys(graphData)?.map((percentage, id) => {
            let isArray = Array?.isArray(graphData?.[percentage]);
            return (
              <div className={style.values} key={id}>
                <div className={style.value}>
                  <div
                    className={
                      id === 0
                        ? style.value3
                        : id === 1
                        ? style.value2
                        : style.value1
                    }
                  >
                    <span>
                      {isArray
                        ? graphData?.[percentage]?.[0] || "0"
                        : graphData?.[percentage] || "0"}
                      %
                    </span>{" "}
                    out of TAT
                  </div>
                  <p className={style.p}>
                    Total {Object.values(showTotalCases)[id]} cases
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </Grid>
      <Grid
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        xs={12}
        sm={12}
        md={6}
        lg={5}
        item
      >
        <Chart
          options={options}
          series={Object?.values(graphData)}
          type="radialBar"
          width="250px"
        />
      </Grid>
    </Grid>
  );
}
